import * as React from "react"
import { SVGProps } from "react"

const Wait = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.018 1.25c-1.444 0-2.514.971-2.52 2.5 0 .406.122.828.352 1.289.18.361.418.733.703 1.113.218.29.452.564.684.82.062.07.088.105.137.157v.742c-.05.052-.075.088-.137.156-.232.257-.466.532-.684.82-.285.381-.523.753-.703 1.114-.23.46-.353.883-.351 1.289.005 1.529 1.075 2.5 2.52 2.5h4.999c1.442 0 2.486-.968 2.48-2.5 0-.404-.12-.83-.35-1.289a7.56 7.56 0 0 0-.704-1.114c-.217-.29-.452-.562-.684-.82-.061-.068-.088-.104-.136-.156V7.13c.048-.052.075-.088.136-.156.232-.258.467-.53.684-.82a7.56 7.56 0 0 0 .703-1.114c.23-.46.35-.885.352-1.289.005-1.532-1.039-2.5-2.481-2.5h-5Zm0 1.25h5c.771 0 1.234.433 1.23 1.25 0 .181-.082.44-.234.742a6.273 6.273 0 0 1-.585.918c-.194.258-.398.51-.606.742-.124.139-.222.222-.274.274a.638.638 0 0 0-.175.449v1.25c0 .166.058.332.175.45.052.05.15.134.274.273.208.231.412.484.606.742.242.323.443.633.585.918.152.302.234.56.235.742.003.818-.46 1.25-1.231 1.25h-5c-.78 0-1.266-.438-1.27-1.25 0-.18.085-.441.235-.742.143-.285.342-.594.586-.918.193-.257.397-.512.605-.742.124-.138.223-.223.274-.274a.634.634 0 0 0 .176-.449v-1.25a.634.634 0 0 0-.176-.45c-.051-.05-.15-.135-.274-.273-.208-.23-.412-.485-.605-.742a6.143 6.143 0 0 1-.586-.918c-.15-.3-.235-.562-.234-.742.003-.813.489-1.25 1.27-1.25Z"
      fill="#fff"
    />
    <path
      d="M7.5 8.75c-.625 0-1.875 1.25-2.5 2.5h5c-.625-1.25-1.875-2.5-2.5-2.5Z"
      fill="#fff"
    />
  </svg>
)

export default Wait
